"use client";

import { ReactNode } from "react";
import {
  LayoutDashboard,
  PlusCircle,
  FileText,
  FileCheck,
  Briefcase,
  Shield,
  Building,
  Clock,
} from "lucide-react";
import { Header, Sidebar, NavItem } from "@/components/layouts";
import { ProtectedRoute } from "@/components/auth";

// =============================================================================
// Navigation Configuration
// =============================================================================

const facilityNavItems: NavItem[] = [
  {
    label: "Dashboard",
    href: "/facility-dashboard",
    icon: LayoutDashboard,
  },
  {
    label: "Manage Jobs",
    href: "/manage-jobs",
    icon: Briefcase,
  },
  {
    label: "Post Job",
    href: "/manage-jobs/new",
    icon: PlusCircle,
  },
  {
    label: "Applications",
    href: "/facility-applications",
    icon: FileText,
  },
  {
    label: "Contracts",
    href: "/facility-contracts",
    icon: FileCheck,
  },
  {
    label: "Timesheets",
    href: "/facility-timesheets",
    icon: Clock,
  },
  {
    label: "Compliance",
    href: "/compliance",
    icon: Shield,
  },
  {
    label: "Facility Profile",
    href: "/facility-profile",
    icon: Building,
  },
];

// =============================================================================
// Layout Component
// =============================================================================

interface FacilityLayoutProps {
  children: ReactNode;
}

export default function FacilityLayout({ children }: FacilityLayoutProps) {
  // TODO: Get user data from auth context/session
  const userData = {
    name: "Memorial Medical Center",
    email: "admin@memorialmedical.com",
  };

  return (
    <ProtectedRoute requireRole="facility" requireVerified>
      <div className="min-h-screen bg-slate-50">
        <Header
          userType="facility"
          userName={userData.name}
          userEmail={userData.email}
        />
        <Sidebar navItems={facilityNavItems} />
        {children}
      </div>
    </ProtectedRoute>
  );
}
